export default __webpack_public_path__ + "static/ibmax-9390fad2c6e257d267adb4d8306bb578.jpg";